import React from "react";
import { UploadSlipFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";

const UploadSlipForm = ({ onSubmit }) => {
  const schema = yup.object().shape({
    slip_file: yup.array().required("กรุณากรอก / Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { t } = useTranslation(["common"]);

  return (
    <UploadSlipFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap mb_30">
          <div className="form_label">
            แจ้งการโอนเงิน / Upload transfer slip
          </div>
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Upload
                {...field}
                placeholder={"อัพโหลดรูปใบเสร็จ / Upload file"}
                errors={errors.slip_file?.message}
              />
            )}
            name="slip_file"
            // defaultValue=""
          />
        </div>

        <div className="btn_submit_wrap">
          <Buttons.BgStandard
            theme_radius_50
            disabled={isSubmitting || !isValid}
            type="submit"
            label={t("Confirm", { ns: "common" })}
          />
        </div>
      </form>
    </UploadSlipFormStyled>
  );
};

UploadSlipForm.propTypes = {};

export default UploadSlipForm;
